<div id="myModal" class="modal fade" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg modal-signing">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h6 class="modal-title text-bold">{{ "Signer" | translate | uppercase }}: <b>{{ theRecipient?.name || '' }}</b></h6>
        <button type="button" class="cancel-btn" (click)="goBack()">
          <i class="ph-bold ph-x"></i>
          <span translate>Cancel</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container-fluid">

          <!-- Reason and Location inputs - optional, compact -->
          <div *ngIf="showReasonLocation && !isSigningInProgress" class="signing-optional-fields">
            <div class="optional-field">
              <label for="tbReason" class="optional-label" translate>Signing Reason</label>
              <input [(ngModel)]="signingReason" [disabled]="isSigningDisabled" class="form-control form-control-sm" id="tbReason" type="text" [placeholder]="'e.g. Approval, Confirmation' | translate">
            </div>
            <div class="optional-field">
              <label for="tbLocation" class="optional-label" translate>Signing Location</label>
              <input [(ngModel)]="signingLocation" [disabled]="isSigningDisabled" class="form-control form-control-sm" id="tbLocation" type="text" [placeholder]="'e.g. Istanbul' | translate">
            </div>
            <span class="optional-hint" translate>(Optional)</span>
          </div>

          <!-- Tabs -->
          <div class="row">
            <ul id="tabs" class="nav nav-tabs-signing">
              <!-- USB E-Signature Tab -->
              <li *ngIf="isMethodEnabled('usb')" class="active" [class.disabled]="isSigningDisabled">
                <a [attr.data-toggle]="isSigningDisabled ? null : 'tab'" [attr.href]="isSigningDisabled ? null : '#open_eid_sign'">
                  <i class="ph-bold ph-usb"></i>
                  <span class="tab-text">{{ "USB E-Signature" | translate }}</span>
                </a>
              </li>

              <!-- Mobile Sign Tab -->
              <li *ngIf="isMethodEnabled('mobile')" [class.disabled]="isSigningDisabled">
                <a [attr.data-toggle]="isSigningDisabled ? null : 'tab'"
                   [attr.href]="isSigningDisabled ? null : '#mobil_sign'">
                  <i class="ph-bold ph-device-mobile"></i>
                  <span class="tab-text">{{ "Mobile Sign" | translate }}</span>
                </a>
              </li>
            </ul>

            <div class="tab-content">

              <!-- TAB: USB E-Signature -->
              <div id="open_eid_sign" class="tab-pane fade in active">
                <!-- Requirements and Download Section -->
                <div class="usb-sign-content" *ngIf="!isSignDocumentClicked && !showChooseCertificateText && !afterPinTextEntered">
                  <div class="usb-sign-grid">
                    <!-- Requirements Card -->
                    <div class="info-card requirements-card">
                      <div class="info-card-header">
                        <i class="ph-bold ph-list-checks"></i>
                        <span translate>Requirements</span>
                      </div>
                      <div class="info-card-body">
                        <ul class="requirements-list">
                          <li>
                            <i class="ph-bold ph-check-circle"></i>
                            <span translate>Chrome browser with signing extension</span>
                          </li>
                          <li>
                            <i class="ph-bold ph-check-circle"></i>
                            <span translate>USB smart card reader</span>
                          </li>
                          <li>
                            <i class="ph-bold ph-check-circle"></i>
                            <span translate>Qualified electronic certificate</span>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <!-- Download Card -->
                    <div class="info-card download-card">
                      <div class="info-card-header">
                        <i class="ph-bold ph-puzzle-piece"></i>
                        <span translate>Chrome Extension</span>
                      </div>
                      <div class="info-card-body">
                        <div class="download-buttons">
                          <a href="https://imzayeri.com/files/imzayeri_web_eid_qt6.msi" class="btn btn-download" target="_blank">
                            <i class="ph-bold ph-windows-logo"></i>
                            Windows
                          </a>
                          <a href="https://imzayeri.com/files/imzayeri_web_eid_mac.dmg" class="btn btn-download" target="_blank">
                            <i class="ph-bold ph-apple-logo"></i>
                            Mac OS
                          </a>
                        </div>
                        <p class="download-note" translate>Restart your browser after installation.</p>
                        <p class="download-note">
                          <a href="https://hub.ilerian.com/tr-tr/imza-yeri-eimza-kurulum" target="_blank" translate>View installation instructions</a>
                        </p>
                      </div>
                    </div>
                  </div>

                  <!-- Legal Note -->
                  <div class="legal-note">
                    <i class="ph-bold ph-info"></i>
                    <span translate>This signature is a secure electronic signature compliant with the electronic signature law numbered 5070.</span>
                  </div>
                </div>

                <!-- Signing Status Messages -->
                <div *ngIf="isSignDocumentClicked || showChooseCertificateText || afterPinTextEntered" class="signing-status">
                  <div class="signing-status-icon">
                    <i class="ph-bold ph-spinner spinning"></i>
                  </div>
                  <label class="signing-status-text">
                    <span *ngIf="isSignDocumentClicked">{{ 'Connecting to the device...' | translate }}</span>
                    <span *ngIf="showChooseCertificateText">{{ 'Please choose your QES certificate' | translate }}</span>
                    <span *ngIf="afterPinTextEntered">{{ 'Signing in progress, please wait' | translate }}</span>
                  </label>
                </div>

                <!-- Sign Button -->
                <div class="text-right sign-button-container">
                  <button *ngIf="requestCode"
                          [disabled]="showChooseCertificateText || isSignDocumentClicked || afterPinTextEntered"
                          class="btn btn-lg btn-primary btn-sign"
                          type="button"
                          (click)="openEidSign()"
                          translate>Sign Document</button>
                </div>
              </div>

              <!-- TAB: Mobile Sign -->
              <div id="mobil_sign" class="tab-pane fade">
                <!-- First Page - Form -->
                <div [hidden]="isMobilSignSecondPage" class="mobile-sign-form-container">
                  <form #mobileForm="ngForm" [ngClass]="{ 'disabled': isMobilSignClicked}" novalidate>

                    <!-- Info Text -->
                    <div class="mobile-sign-info">
                      <p translate>If you have an active mobile signature obtained from GSM operators, you can sign the document by entering your operator and number.</p>
                    </div>

                    <!-- Mobile Form Fields Box -->
                    <div class="mobile-form-box">
                      <!-- Phone Number Input - inline -->
                      <div class="mobile-form-row">
                        <label class="mobile-row-label" translate>Phone Number</label>
                        <div class="mobile-row-content">
                          <input type="tel" id="mobileNumber" name="mobileNumber" class="form-control mobile-phone-input" placeholder="05__ ___ __ __"
                                 [(ngModel)]="mobilSignModel.mobile" #mobileNumber="ngModel"
                                 required minlength="11" maxlength="11" pattern="^(05)[0-9]{9}$">
                          <small [hidden]="mobileNumber.valid || (mobileNumber.pristine && !mobileForm.submitted)" class="text-danger"
                                 [innerHTML]="'MOBILE_REQUIRED_SIGNING' | translate"></small>
                        </div>
                      </div>

                      <!-- GSM Operator Selection - inline -->
                      <div class="mobile-form-row">
                        <label class="mobile-row-label" translate>GSM Operator:</label>
                        <div class="mobile-row-content">
                          <div class="operator-cards">
                            <label *ngFor="let operator of operators" class="operator-card" [class.selected]="mobilSignModel.operator === operator.value">
                              <input type="radio" name="operator" [(ngModel)]="mobilSignModel.operator" [value]="operator.value">
                              <div class="operator-card-content">
                                <span class="operator-name">{{ translate.instant(operator.display) }}</span>
                              </div>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Connecting Status -->
                    <div *ngIf="isSignDocumentClickedMobile" class="signing-status">
                      <div class="signing-status-icon">
                        <i class="ph-bold ph-spinner spinning"></i>
                      </div>
                      <label class="signing-status-text">
                        {{ 'Connecting to GSM Operator' | translate }}
                      </label>
                    </div>

                    <!-- Next Button -->
                    <div class="text-right sign-button-container">
                      <button *ngIf="requestCode"
                              type="button"
                              class="btn btn-lg btn-primary btn-sign"
                              (click)="mobileSign(mobileForm.value); isMobilSignClicked = true"
                              [disabled]="!mobileForm.valid || isSignDocumentClickedMobile"
                              translate>Next</button>
                    </div>
                  </form>
                </div>

                <div class="clearfix"></div>

                <!-- Second Page - Waiting for confirmation -->
                <div [hidden]="!isMobilSignSecondPage" class="mobile-sign-waiting">

                  <!-- Fingerprint Box -->
                  <div *ngIf="fingerPrint" class="fingerprint-box" [class.initial-signing]="isInitialSigning">
                    <!-- Initial Signing Info Banner -->
                    <div *ngIf="isInitialSigning && isWaitingForRealFingerprint" class="initial-signing-info">
                      <i class="ph-bold ph-info"></i>
                      <span translate>First time signing - please confirm on your phone</span>
                    </div>

                    <div class="fingerprint-header">
                      <i class="ph-bold ph-fingerprint"></i>
                      <span translate>Finger Print</span>
                    </div>
                    <div class="fingerprint-value">{{ fingerPrint }}</div>
                    <div class="fingerprint-warning">
                      <i class="ph-bold ph-warning"></i>
                      <span translate>Verify this fingerprint matches the one on your phone</span>
                    </div>
                  </div>

                  <!-- Progress Bar -->
                  <div class="progress-container">
                    <div class="progress">
                      <div class="progress-bar progress-bar-striped active" style="width: 100%;">
                        <span class="sr-only" translate>100% Complete</span>
                      </div>
                    </div>
                    <span class="progress-label">
                      <span *ngIf="isWaitingForRealFingerprint" translate>Verifying certificate...</span>
                      <span *ngIf="!isWaitingForRealFingerprint" translate>Waiting for confirmation...</span>
                    </span>
                  </div>

                  <!-- Step Cards -->
                  <div class="mobile-sign-steps">
                    <div class="step-card">
                      <div class="step-number">1</div>
                      <i class="ph-bold ph-device-mobile-speaker"></i>
                      <span class="step-title" translate>Notification Coming</span>
                    </div>
                    <div class="step-arrow">
                      <i class="ph-bold ph-arrow-right"></i>
                    </div>
                    <div class="step-card">
                      <div class="step-number">2</div>
                      <i class="ph-bold ph-fingerprint"></i>
                      <span class="step-title" translate>Verify Fingerprint</span>
                    </div>
                    <div class="step-arrow">
                      <i class="ph-bold ph-arrow-right"></i>
                    </div>
                    <div class="step-card">
                      <div class="step-number">3</div>
                      <i class="ph-bold ph-lock-key"></i>
                      <span class="step-title" translate>Enter PIN</span>
                    </div>
                  </div>

                  <!-- Instructions -->
                  <div class="mobile-sign-instructions">
                    <p translate>Confirm the notification on your phone, verify the fingerprint matches, and enter your mobile signature PIN.</p>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <!-- Hidden close button for programmatic modal dismiss -->
          <button type="button" id="closeModalButton" class="btn btn-hide" data-dismiss="modal">Close</button>

        </div>
      </div>
    </div>
  </div>
</div>
